// extracted by mini-css-extract-plugin
export default {"faqModal":"DocumentsModal_faqModal__5K9r+","closeBtn":"DocumentsModal_closeBtn__vls9w","faqItem":"DocumentsModal_faqItem__FL60T","scaleIn":"DocumentsModal_scaleIn__mgIIc"};